export default "__VITE_ASSET__DcoB2U3v__"